import React from "react";
import { Rating } from "@material-ui/lab";
import styles from "./FeedbackRating.module.scss";
import makeStyles from "@material-ui/styles/makeStyles";
import StarBorderIcon from "@material-ui/icons/StarBorder";

const useStyles = makeStyles(theme => ({
  root: {
    fontSize: "2.75rem",
    "& .MuiRating-icon": {
      marginLeft: "0.75rem",
      marginRight: "0.75rem",
    },
    "& .MuiSvgIcon-fontSizeInherit": {
      fill: "#E35646",
    },
    "& label:nth-of-type(1):after": {
      content: '"Totally\\a dissatisfied"',
      color: "#757575",
      whiteSpace: "pre",
      fontSize: "0.75rem",
      position: "absolute",
      textAlign: "center",
      paddingTop: "0.875rem",
    },
    "& label:nth-of-type(5):after": {
      content: '"Fairly\\a satisfied"',
      color: "#757575",
      whiteSpace: "pre",
      fontSize: "0.75rem",
      paddingLeft: "0.75rem",
      position: "absolute",
      textAlign: "center",
      paddingTop: "0.875rem",
    },
    "& label:nth-of-type(10):after": {
      content: '"Outstanding"',
      color: "#757575",
      fontSize: "0.75rem",
      position: "absolute",
      textAlign: "center",
      paddingTop: "0.875rem",
    },
  },
}));

const FeedbackRating = ({
  inputID,
  rating,
  updateRatingFormData,
  updateMandatoryInputFlag,
}) => {
  const classes = useStyles();

  return (
    <div className={styles.containerWrapper}>
      <div id={inputID} className={styles.container}>
        <Rating
          className={classes.root}
          value={rating}
          onChange={event => {
            const inputID = event.target.parentNode.parentNode?.id;
            updateRatingFormData({ inputID, [inputID]: event.target.value });
            if (updateMandatoryInputFlag) {
              updateMandatoryInputFlag({ inputID });
            }
          }}
          max={10}
          precision={1}
          emptyIcon={<StarBorderIcon fontSize="inherit" />}
        />
      </div>
    </div>
  );
};

export default FeedbackRating;
